export const uniqueId = (() => {
  let id = 1;
  return (prefix = "uid_") => {
    id++;
    return prefix + "_" + id;
  };
})();
